import { Outlet, useLocation, useParams } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { AtsCandidateDetailDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { CandidateSideContent } from './SideContent'

const CandidateDetailPage = () => {
  const { id } = useParams()
  const { pathname } = useLocation()
  const { company } = useCurrentSession()
  const { navigation } = useNavigation()

  const { loading, data } = useQuery(AtsCandidateDetailDocument, {
    variables: { id: Number(id), companyId: company.id },
  })

  const candidate = data?.ats.candidate

  const isResumePath = pathname === navigation.ats.candidates.id.cv.fullPath({ id: Number(id) })

  if (loading || !candidate) {
    return (
      <Box padding="s40" alignItems="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <Box flexDirection="row" width="full">
      <Box
        flexNoShrink
        height="full"
        overflowY="auto"
        overflowX="hidden"
        paddingY={isResumePath ? 's0' : 's20'}
        paddingX={isResumePath ? 's0' : 's24'}
        paddingLeft={isResumePath ? 's1' : 's24'}
        border={{ right: { style: 'solid', width: 's1', color: 'grey200' } }}
        style={{ width: '75%' }}
      >
        <Outlet context={{ candidate }} />
      </Box>
      <Box
        flexGrow
        height="full"
        overflowY="auto"
        paddingTop="s20"
        paddingRight="s16"
        paddingLeft="s8"
        paddingBottom="s24"
      >
        <CandidateSideContent data={candidate} />
      </Box>
    </Box>
  )
}

export default CandidateDetailPage
